<template>
  <div :class="{'jo-table':true,'rc_mode':layout=='rc'}">
    <div :id="data.id">
      <!-- 表头Start -->
      <div style="margin: 20px auto 20px auto;">
        <div v-if="this.data.caption.length > 0" class="jo-main-title" v-bind:style="{'width':scaleWidth+'px','color' : this.ARTICLE.theme}">
          <component :is="'jo' + item.name" v-for="item in this.data.caption[0].label" v-bind:key="item.index"
                     v-bind:data="item.data"></component>&nbsp;
          <component :is="'jo' + item.name" v-for="item in this.data.caption[0].title" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          <span v-if="this.data.caption[0].label && this.data.cellunit">
          <span v-for="item1 in this.data.cellunit" v-if="item1.lang==data.caption[0].lang">(
          <component :is="'jo' + item.name" v-for="item in item1.data" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          )</span>
        </span>
        </div>

        <div v-if="this.data.caption.length > 1" class="jo-sub-title" v-bind:style="{'width':scaleWidth+'px','color' : this.ARTICLE.theme}">
          <component :is="'jo' + item.name" v-for="item in this.data.caption[1].label" v-bind:key="item.index"
                     v-bind:data="item.data"></component>&nbsp;
          <component :is="'jo' + item.name" v-for="item in this.data.caption[1].title" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          <span v-if="this.data.caption[1].label && this.data.cellunit">
          <span v-for="item1 in this.data.cellunit" v-if="item1.lang==data.caption[1].lang">(
          <component :is="'jo' + item.name" v-for="item in item1.data" v-bind:key="item.index"
                     v-bind:data="item.data"></component>
          )</span>
        </span>
        </div>
      </div>

      <!--表前图-->
      <div v-if="this.data.beforegraphics" align="center">
        <img v-for="graphic in this.data.beforegraphics" :src="graphic.big" :style="{ 'width': calWidth(graphic.width) + 'px', 'height': calHeight(graphic.height) + 'px', 'max-width' : '100%' }" alt="table"/>
      </div>

      <!-- 表头End -->
      <div style="margin-top:10px; overflow-x:auto; overflow-y:auto; max-height: 600px" v-for="(tableItem,tableIndex) in data.table" :key="data.id + tableIndex">
        <table cellspacing="0" cellpadding="0" ref="table" :border="setCellStyle(tableItem.style,true)"
               v-if="tableItem.head.length > 0 || tableItem.body.length > 0">
          <thead v-if="tableItem.head.length > 0" >
          <tr v-for="(item, index) in tableItem.head" v-bind:key="index">
            <th v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align"
                :style="setCellStyle(item2.style,false)">
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </th>
          </tr>
          </thead>
          <tbody v-if="tableItem.body.length > 0">
          <tr v-for="(item, index) in tableItem.body" v-bind:key="index">
            <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align" :class="{'formula-td':hasFormula(item2.data)}"
                :style="setCellStyle(item2.style,false)">
              {{ item2.index }}
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </td>
          </tr>
          </tbody>
          <tfoot v-if="tableItem.foot && tableItem.foot.length > 0">
          <tr v-for="(item, index) in tableItem.foot" v-bind:key="index">
            <td v-for="(item2, index2) in item" v-bind:key="index2" :rowspan="item2.rowspan" :colspan="item2.colspan"
                :align="item2.align"
                :style="setCellStyle(item2.style,false)">
              {{ item2.index }}
              <component :is="'jo' + item3.name" v-for="item3 in item2.data" v-bind:key="item3.index"
                         v-bind:data="item3.data"></component>
            </td>
          </tr>
          </tfoot>
        </table>
        <img v-else-if="this.data.hasOwnProperty('graphics') && this.data.graphics.hasOwnProperty('big')" v-lazy="this.data.graphics.big" v-bind:style="{ 'width': width + 'px', 'max-width' : '100%' }" alt="table"/>
      </div>

      <div class="jo-table-note" v-if="this.data.note.length > 0" v-bind:style="{'width':scaleWidth+'px'}">
        <div v-for="note in this.data.note">
          <!--<span v-if="note.data[0].name && note.data[0].name != 'vocab'" style="font-weight: bold; font-size: 1.2rem">{{note.lang=='zh'? '注：':'NOTE:'}}</span>-->
          <span v-for="(item, index) in note.data">
          <component :is="'jo' + item.name" class="note" v-bind:key="item.index"
                      v-bind:data="item.data"></component>
          <span v-if="index < note.data.length - 1 && !hasColon(item) ">{{note.lang=='zh'?'；':'; '}}</span>
        </span>
        </div>
      </div>

      <div v-if="showDownload()" class="jo-download">
        <img src="../../../../assets/img/fig-download.png" alt="icon"/>
        <span>{{ARTICLE.defaultlang == 'zh' ? '下载' : 'Download'}}:&nbsp;</span>
        <a :href="setDownloadTableUrl(data.id)">{{ARTICLE.defaultlang == 'zh' ? '导出CSV' : 'Export CSV'}}</a>
      </div>

    </div>
    <el-dialog v-if="this.data.hasOwnProperty('graphics') && this.data.graphics.hasOwnProperty('big')" width="inherit" top="0" custom-class="bigPicDialog" :visible.sync="isShowBigTable">
      <img :src="this.data.graphics.big" :style="{ 'max-height': picHeight + 'px' }" alt="table">
    </el-dialog>
  </div>
</template>

<script>
  /* eslint-disable */
  import joinlineformula from '../formula/inlineformula.vue'
  import jointablefig from '../fig/intablefig.vue'
  import joinlinegraphic from '../fig/inlinegraphic.vue'

  export default {
    components: {
      jointablefig,
      joinlineformula,
      joinlinegraphic
    },
    props: [
      'data'
    ],
    data() {
      return {
        isShowBigTable: false,
        picHeight: "inherit",
        tableWidth: 500,
        tableHeight:1,
        width: 10,
        wrapWidth:1,
        scaleValue: 1,
//        hideVocab:true

      }
    },
    mounted() {
      /*if (navigator.userAgent.indexOf('Firefox')>-1){
       $(this.$refs.table).css('border-collapse','unset')
       }*/
      this.wrapWidth = $('.jo-table').width();
      let _this = this;
//      setTable()

      function setTable () {
        _this.tableHeight = $(_this.$refs.table).height();
        _this.tableWidth = $(_this.$refs.table).width();
      }

      //表格中有图片需要等图片加载完成获取表格高度
      let imgs = $(this.$refs.table).find('img');
      let num = imgs.length;
      if (num > 0) {
        imgs.each(function () {
          if (this.getAttribute('src')===null){
            num--;
            return
          }
          let img = new Image();
          img.src = this.getAttribute('src')
          img.onload = function () {
            num--;
            if (num < 1) {
              setTable()
            }
          }
        })
      }
      if($(this.$refs.table).find('.jo-formula').length>0){
        MathJax.Hub.Queue(["Typeset", MathJax.Hub,_this.$refs.table],[setTable]);
      } else setTable();

      $(window).on('resize', function () {
        if ($(_this.$refs.table).is(":visible")) {
          _this.tableWidth = $(_this.$refs.table).width();
          _this.wrapWidth = $('.jo-table').width();
          _this.tableHeight = $(_this.$refs.table).height();
        }
      })
    },
    methods: {
      showBigTable() {
        this.isShowBigTable = true;
        this.picHeight = document.documentElement.clientHeight - 100;
      },
      calWidth(width){
        return width * this.GLOBAL.deviceDPI.x / 25.4
      },
      calHeight(height){
        return height * this.GLOBAL.deviceDPI.y / 25.4
      },
      setCellStyle(style,isOut){
//        使用index判断是否为外边框
        /*if(ifFoot !== -1) {
         console.log(ifFoot);
         console.log(index);
         }*/
        let border;
        let borderWidth = 1;
        if (isOut){
          borderWidth = 2;
        }
        let borderDoubleWidth = 3;
        if (style && style!==''){
          border = style + ';border-width:'+borderWidth+'px;border-color: #333;'
          if (style.search(/border-top:Double/i)>=0){
            border += ';border-top-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-right:Double/i)>=0){
            border += ';border-right-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-bottom:Double/i)>=0){
            border += ';border-bottom-width:'+borderDoubleWidth+'px;';
          }
          if (style.search(/border-left:Double/i)>=0){
            border += ';border-left-width:'+borderDoubleWidth+'px;';
          }
        }
        return border;
      },
      hasColon(item){
        let hasColon = false;
        if (item.name === 'p'){
          hasColon = this.hasColon(item.data[item.data.length-1]);
        } else if (item.name==='text'){
          if(item.data.lastIndexOf(';')===item.data.length-1 ||
            item.data.lastIndexOf('；')===item.data.length-1){
            return true
          }
        }
        return hasColon;
      },
      hasFormula(data){
        for (let i = 0; i < data.length; i++){
          if (data[i].name == "inlineformula"){
            return true;
          }
        }
        return false
      },
      setDownloadTableUrl(tableId){
        if (this.ARTICLE.offline && this.ARTICLE.offline == true){
          let title = $('.carousel-title-content-ch .main-title').text().replace(/\s/g,"");
          return './table/' + title + '.xls'
        } else if (this.hostUrl && this.hostUrl !== '') {
          return  this.hostUrl + 'downloadTable?tableId='+tableId + '&type=xls';
        } else return  window.location.pathname + 'downloadTable?tableId='+tableId + '&type=xls';
      },
      showDownload() {
        let userAgent = window.navigator.userAgent.toLowerCase();
        return this.layout== 'rc' && userAgent.match(/MicroMessenger/i) != 'micromessenger' && this.data.table && this.data.table.length > 0;
      }
    },
    created () {
      if(this.data.hasOwnProperty("graphics") && this.data.graphics.hasOwnProperty("width"))
        this.width = this.data.graphics.width * this.GLOBAL.deviceDPI.x / 25.4
    },
    computed:{
      scale: function () {
        if(this.wrapWidth<this.tableWidth && this.wrapWidth>1){
          this.scaleValue = this.wrapWidth / this.tableWidth;
          if (navigator.userAgent.indexOf("Firefox")>-1){
            $(this.$refs.table).css({'-moz-transform':'scale('+this.scaleValue+')'})
          }
          return  'scale('+this.scaleValue+')';
        }else this.scaleValue=1;
      },
      wrapHeight: function () {
        this.tableHeight = $(this.$refs.table).height()
        return this.tableHeight
      },
      scaleWidth: function () {
        return this.tableWidth * this.scaleValue
      }
    }
  }
</script>
<style lang="scss" scoped>

  .jo-main-title, .jo-sub-title {
    width: 100px;
    text-align: center;
    font-size: 1.2rem;
    /*height: 20px;*/
    line-height: 18px;
    color: #00A2AF;
    font-weight: bold;
    margin: 0 auto 5px auto;
    max-width: 100%;
  }

  /* 重写干扰部分 */
  .jo-main-title .jo-sup, .jo-sub-title .jo-sup {
    display: inline-block;
  }

  .jo-table-border-none{
    border:none!important;
  }

  .outside-top-border{
    border-spacing: 0;
    border-collapse: unset;
    border-top: 2px solid #333;
  }

  .outside-bottom-border {
    border-spacing: 0;
    border-collapse: unset;
    border-bottom: 2px solid #333;
  }

  .jo-table {
    background-color: #ffffff;
    margin: 1.5rem 20px;
    width: 100%;
    table {
      border-spacing: 0;
      border-collapse: collapse;
      border-left: none;
      border-right: none;
      border-top: 2px solid #333;
      border-bottom: 2px solid #333;
      min-width: 60%;
      margin: 0 auto 0 auto;
      table-layout: fixed;
      text-align: center;
      transform-origin: 0 0;
      -ms-transform-origin: 0 0;
      thead {
        th {
          border: none;
          font-size: 1.4rem;
          color: #333;
          padding: 5px;
          max-width: 400px;
          word-break: normal;
        }
      }
      tbody {
        td {
          border: none;
          font-size: 1.4rem;
          color: #333;
          padding: 5px;
          min-width: 80px;
          max-width: 400px;
          word-break: normal;
          overflow-x: auto;
          vertical-align: middle;
        }
      }
      tfoot {
        td {
          border: none;
          font-size: 1.4rem;
          color: #333;
          padding: 5px;
          max-width: 400px;
          word-break: normal;
        }
      }
      span {
        height: 30px;
        display: inline;
        line-height: 30px;
        font-size: 14px;
        color: #333;
      }
    }
    p {
      line-height: 30px;
      margin-bottom: 0;
      text-indent: 0;
      color: #333;
      text-align: inherit;
      font-size: 14px;
      min-height: 30px;
    }
    .formula-td{
      max-width: 800px;
    }
    .jo-download {
      font-size: 1.4rem;
      color: #999999;
      text-align: right;
      padding-right: 20px;
      a{
        cursor: pointer;
      }
    }
  }
  td::-webkit-scrollbar{
    height: 5px;
  }
  td::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: rgba(0,0,0,0.2);
  }
  td::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 0;
    background: rgba(0,0,0,0.1);

  }

  .jo-table-note {
    margin: 6px auto 0 auto;
    min-width: 60%;
    .note {
      display: inline;
      line-height: 18px;
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/maincontent/body/table/table.vue